<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pd_inoutno,pd_ordercode,product.pr_code,product.pr_detail"
      placeholder="输入单据编号、制造单号、产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/production/disassemble_in/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pi_inoutno}}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.pi_date}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.pr_detail}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.pi_status!='已审核'}"
          >{{item.pi_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('pi_total')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/prodinout/list",
      params: {
        caller: 'MakeIn'
      },
      filters: [
        {
          type: "date",
          name: "pi_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              mode: 'DETAIL',
              condition: "pi_class='MAKEDISASSEMBLEIN'"
            },
            {
              value: 1,
              label: "待完工",
              mode: 'DETAIL',
              condition: "pi_class = 'MAKEDISASSEMBLEIN' AND PI_STATUS <> '已审核'"
            },
            {
              value: 2,
              label: "已完工",
              mode: 'DETAIL',
              condition: "pi_class = 'MAKEDISASSEMBLEIN' AND PI_STATUS = '已审核'"
            }
          ]
        }
      ]
    };
  }
};
</script>